import { graphql } from '~/lib/graphql'

export const ReserveInfoOptionMenus = graphql(`
  fragment ReserveInfoOptionMenus on ReserveInfo {
    optionMenus {
      availability
      optionMenu {
        optionMenuId
        name
        price
        image {
          url
          name
        }
        description
        maxOrderPerReservation
      }
    }
  }
`)
